import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
      isHaveContact: 1,
    }
  },
  // book
  {
    path: '/book',
    name: 'book',
    component: () => import(/* webpackChunkName: "about" */ '../views/book/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
      isHaveContact: 1,
    }
  },

  // 专题
  {
    path: '/course',
    name: 'course',
    component: () => import(/* webpackChunkName: "about" */ '../views/courses/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
      isHaveContact: 1,
    }
  },
  // 详情 - 目录
  {
    path: '/course/detail',
    name: 'courseetaDil',
    component: () => import(/* webpackChunkName: "about" */ '../views/course/detail/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
    }
  },
  // 详情 - 评论
  {
    path: '/course/detail/commentTab',
    name: 'courseetaDil',
    component: () => import('../views/course/detail/tabView/commentTab/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
    }
  },
  // 详情 - 介绍
  {
    path: '/course/detail/introduceTab',
    name: 'courseetaDil',
    component: () => import('../views/course/detail/tabView/introduceTab/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
    }
  },
  // 教师团队
  {
    path: '/teacher/list',
    name: 'teacherList',
    component: () => import(/* webpackChunkName: "about" */ '../views/teacher/list/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
    }
  },
  {
    path: '/teacher/list',
    name: 'teacherList',
    component: () => import(/* webpackChunkName: "about" */ '../views/teacher/list/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
    }
  },
  {
    path: '/teacher/detail',
    name: 'teacherDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/teacher/detail/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
    }
  },

  {
    path: '/my',
    name: 'mineCourse',
    component: () => import(/* webpackChunkName: "about" */ '../views/mine/course/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
      isHaveContact: 1,
    }
  },
  // 个人中心-我的专题课程
  {
    path: '/mine/specialCourse',
    name: 'mineSpecialCourse',
    component: () => import(/* webpackChunkName: "about" */ '../views/mine/specialCourse/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
    }
  },
  // 个人中心-修改/保存我的信息
  {
    path: '/mine/saveInfo',
    name: 'mineSaveInfo',
    component: () => import(/* webpackChunkName: "about" */ '../views/mine/saveInfo/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
    }
  },
  // 个人中心-我的订单
  {
    path: '/mine/order/list',
    name: 'mineOrderList',
    component: () => import(/* webpackChunkName: "about" */ '../views/mine/order/list/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
    }
  },
  // 个人中心-我的订单详情
  {
    path: '/mine/order/detail',
    name: 'mineOrderDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/mine/order/detail/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
    }
  },
  // 个人中心-我的收藏
  {
    path: '/mine/collect',
    name: 'mineCollect',
    component: () => import(/* webpackChunkName: "about" */ '../views/mine/collect/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
    }
  },

  {
    path: '/app',
    name: 'app',
    component: () => import(/* webpackChunkName: "about" */ '../views/app/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 0,
    }
  },
  {
    // path: '/app/detail',
    path: '/app-detail',
    name: 'appDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/app/detail/index.vue'),
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 0,
    }
  },
  {
    path: '*',
    name: 'home',
    component: Home,
    meta: {
      // 是否保留头
      isHaveTop: 1,
      // 是否保留底部
      isHaveBottom: 1,
      isHaveContact: 1,
    }
  },

 
];

var routerMapObject = {
  routes,
  // mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    if (savedPosition) {
      return savedPosition
    } else {
      return document.body.scrollTop = 0, document.documentElement.scrollTop = 0
    }
  }
}
if (process.env.NODE_ENV == 'production') {
  routerMapObject.mode = 'history'
  routerMapObject.base = '/w/'
}
const router = new VueRouter(routerMapObject);

export default router
